import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { t } from '../../util/messages';
import {
  Page,
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  NamedLink,
} from '../../components';
import { TopbarContainer } from '../../containers';
import css from './NotFoundPage.module.css';

const NotFoundPage = ({ staticContext }) => {
  const [scrollingDisabled, setScrollingDisabled] = useState(false);

  // Mark as not found for server-side rendering
  if (staticContext) {
    staticContext.notfound = true;
  }

  const onManageDisableScrolling = (_id, disabled = false) => {
    setScrollingDisabled(disabled);
  };

  const title = t('NotFoundPage.title');

  return (
    <Page title={title} scrollingDisabled={scrollingDisabled}>
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer onManageDisableScrolling={onManageDisableScrolling} />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain>
          <div className={css.root}>
            <div className={css.content}>
              <p className={css.number} aria-hidden="true">404</p>
              <h1 className={css.heading}>{t('NotFoundPage.heading')}</h1>
              <p className={css.description}>{t('NotFoundPage.description')}</p>

              {/*
                A 404 with no way out is a dead end. Give the visitor the one
                action that always works, plus a route to a human.
              */}
              <div className={css.actions}>
                <NamedLink className={css.primaryAction} name="LandingPage">
                  {t('NotFoundPage.backHome')}
                </NamedLink>
                <NamedLink
                  className={css.secondaryAction}
                  name="LandingPage"
                  to={{ hash: '#contact-us' }}
                >
                  {t('NotFoundPage.orContact')}
                </NamedLink>
              </div>
            </div>
          </div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
};

NotFoundPage.propTypes = {
  staticContext: PropTypes.object,
};

export default NotFoundPage;
